// Mirrors backend/src/pdfTemplates/designA/designAFormatters.js's
// fitItemNameHtml exactly (same thresholds) -- deliberately NOT a live
// browser-measurement pass. Pagination assumes every row is exactly one
// line tall, so the Print Preview and the downloaded PDF must shrink/
// truncate names by the identical deterministic rule; if one side measured
// live and the other estimated, they could occasionally disagree on where a
// name needs shrinking and the two would paginate differently. Returns a
// plain descriptor (not JSX) so the caller renders it as `<span
// style={{fontSize: result.fontSizePercent + '%'}}>{result.text}</span>`
// -- React escapes text nodes on its own, so no HTML-escaping helper is
// needed here the way the backend (raw HTML strings) needs escapeHtml.
export function fitItemName(name, { maxChars = 38, minFontPercent = 72 } = {}) {
  const text = String(name || "");
  const isAllCaps = text === text.toUpperCase() && /[A-Z]/.test(text);
  const effectiveMax = isAllCaps ? Math.round(maxChars * 0.9) : maxChars;

  if (text.length <= effectiveMax) {
    return { text, fontSizePercent: 100, truncated: false };
  }

  const overBy = text.length / effectiveMax;
  const scaledPercent = Math.max(minFontPercent, Math.round(100 / overBy));

  if (scaledPercent > minFontPercent) {
    return { text, fontSizePercent: scaledPercent, truncated: false };
  }

  const truncated = text.slice(0, effectiveMax - 1).trimEnd();
  return { text: `${truncated}…`, fontSizePercent: minFontPercent, truncated: true };
}
